import { GROMMET_UI_DEFAULT_FIELDS } from 'speed-js-react-web';
import MultipleCheckboxes from 'speed-js-react-web/src/components/grommet2/forms/fields/MultipleCheckboxes';
import GenericObjectSelect from 'esm-web-pro/components/forms/fields/GenericObjectSelect';
import Select from 'esm-web-pro/components/forms/fields/Select';
import NumberInput from 'esm-web-pro/components/forms/fields/NumberInput';
import CentsInputFormik from 'esm-web-pro/components/forms/fields/CentsInputFormik';
import AddressPicker from './AddressPicker';
import ColorPicker from './ColorPicker';


export {
    AddressPicker,
};

export const FORM_FIELDS = {
    ...GROMMET_UI_DEFAULT_FIELDS,
    address_picker: AddressPicker,
    color_picker: ColorPicker,
    generic_object_select: GenericObjectSelect,
    multiple_checkboxes: MultipleCheckboxes,
    choice: Select,
    number: NumberInput,
    value_in_cents: CentsInputFormik,
};
